<div class="{{ direction }} {{theme}}" [style.border-width.px]="arrowSize"></div>
